module.exports = __webpack_public_path__ + "static/img/character-5.c0a516f0.png";